import type { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

const StyledParagraph = styled.p<{ $small?: boolean; $strong?: boolean; $staticPage?: boolean }>`
  font-size: 1.125rem;
  letter-spacing: 0.0125rem;
  line-height: 1.6;
  margin-bottom: 1.125rem;

  @media screen and (min-width: 48rem) {
    font-size: 1.5rem;
    line-height: 1.6;
    margin-bottom: 2.5rem;
  }

  a,
  strong {
    font-size: inherit;
    line-height: inherit;
  }

  font-weight: ${({ $strong }) => ($strong ? '700' : '400')};

  ${({ $small }) =>
    $small &&
    css`
      font-size: 1rem;
      line-height: 1.5;
      letter-spacing: 0.0125rem;

      @media screen and (min-width: 48rem) {
        font-size: 1.125rem;
        line-height: 1.6;
      }
    `}
  ${({ $staticPage }) =>
    $staticPage &&
    css`
      line-height: 1.375;
      margin-top: 0;
      @media screen and (min-width: 48rem) {
        line-height: 1.4;
      }

      a {
        color: var(--blue);
      }
    `}
`

const Paragraph: FunctionComponent<{
  children?: ReactNode
  small?: boolean
  style?: object
  strong?: boolean
  staticPage?: boolean
  dangerouslySetInnerHTML?: { __html: TrustedHTML }
}> = ({ children, small, style, strong, staticPage, dangerouslySetInnerHTML, ...otherProps }) => (
  <StyledParagraph
    $small={staticPage || small}
    style={style}
    $strong={strong}
    $staticPage={staticPage}
    dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    {...otherProps}
  >
    {children}
  </StyledParagraph>
)

export default Paragraph
